import { makeStyles } from '@material-ui/core';

export const NAV_WIDTH = 236;
export const NAV_WIDTH_COLLAPSED = 64;

// White label (guía §5): el sidebar es la superficie de marca del dashboard
// (sustituye al TopBar de prod, que usaba palette.primary.main). Puede tener un
// color propio por tenant; si no se configura, hereda el primary de la marca.
export default makeStyles((theme) => ({
  mobileDrawer: {
    width: NAV_WIDTH,
    backgroundColor: theme.palette.sidebar.main,
    border: 'none',
  },
  desktopDrawer: {
    width: NAV_WIDTH,
    backgroundColor: theme.palette.sidebar.main,
    border: 'none',
    transition: 'width .18s ease',
    overflowX: 'hidden',
  },
  desktopMiniDrawer: {
    width: NAV_WIDTH_COLLAPSED,
    backgroundColor: theme.palette.sidebar.main,
    border: 'none',
    transition: 'width .18s ease',
    overflowX: 'hidden',
  },
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    color: theme.palette.common.white,
    // Scroll discreto sobre fondo oscuro
    '& .ps__rail-y': {
      backgroundColor: 'transparent !important',
    },
    '& .ps__thumb-y': {
      backgroundColor: 'rgba(255,255,255,.22)',
    },
  },
  scroll: {
    flex: 1,
    minHeight: 0,
  },
  subheader: {
    color: 'rgba(255,255,255,.4)',
    fontSize: 11,
    fontWeight: 700,
    lineHeight: '28px',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    padding: theme.spacing(1.5, 1.25, 0),
  },
  subheaderDash: {
    display: 'block',
    width: 18,
    height: 1,
    margin: '10px auto 2px',
    backgroundColor: 'rgba(255,255,255,.18)',
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(2, 1.75, 0.5),
    minHeight: 64,
    flexShrink: 0,
  },
  brandWordmark: {
    fontSize: 19,
    fontWeight: 700,
    letterSpacing: '-0.02em',
    color: theme.palette.common.white,
  },
  brandCollapsed: {
    justifyContent: 'center',
    padding: theme.spacing(2, 0),
  },
  brandMark: {
    width: 30,
    height: 30,
    borderRadius: 9,
    backgroundColor: 'rgba(255,255,255,.16)',
    color: theme.palette.common.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 15,
    fontWeight: 700,
    flexShrink: 0,
  },
  collapseButton: {
    marginLeft: 'auto',
    color: 'rgba(255,255,255,.6)',
    padding: 6,
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,.10)',
      color: theme.palette.common.white,
    },
  },
  nav: {
    padding: theme.spacing(1, 1.25),
  },
  navCollapsed: {
    padding: theme.spacing(1, 0.75),
  },
  accountWrapper: {
    marginTop: 'auto',
  },
  account: {
    flexShrink: 0,
    borderTop: '1px solid rgba(255,255,255,.1)',
    padding: theme.spacing(1.5, 1.25),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    // El menú de cuenta existente se conserva; solo se adapta al fondo oscuro
    '& .MuiTypography-root': {
      color: theme.palette.common.white,
      fontSize: 13,
      fontWeight: 600,
    },
    '& .MuiSvgIcon-root': {
      color: 'rgba(255,255,255,.6)',
    },
    '& .MuiAvatar-root': {
      backgroundColor: theme.palette.primary.main,
      width: 32,
      height: 32,
    },
  },
  accountCollapsed: {
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(1.5, 0),
  },
}));
